import Input from "../../../utils/Input";
import Auth from "../../../libs/API/Auth";
import Toast from "../../../components/Toast";
import { GTMEvent } from "../../../utils/Utils";
import SplashScreen from "../../../components/SplashScreen";

class Login {
  constructor() {
    this.main = document.getElementById('login');

    this._splashScreen = new SplashScreen({showDescription: false});
    this._form = this.main.querySelector('.login_form');
    this._passwordToggleShow = this.main.querySelector('.login_password_toggle_show');
    this._inputEmailEl = this.main.querySelector('.login_input_email');
    this._inputPasswordEl = this.main.querySelector('.login_input_password');
    this._inputEmail = new Input(this._inputEmailEl);
    this._inputPassword = new Input(this._inputPasswordEl);
    this._btnLogin = this.main.querySelector('.login_btn');
    this._loginErrorToast = new Toast(this.main.querySelector('.toast-login-incorrect'),'error','Incorrect email or password');
    this._sending = false;

    this._passwordToggleShow.addEventListener('click', this._onClickPasswordToggleShow.bind(this));
    this._form.addEventListener('submit', this._onSubmit.bind(this));
    this.hide = true;
    this._splashScreen.show();

    Auth.addEventListener('sessionReady', (function (logged) {
      if (logged) {
        this._redirect();
      } else {
        this.hide = false;
        this._splashScreen.hide();
      }
    }).bind(this));

    setTimeout(() => {
      this.hide = false;
      this._splashScreen.hide();
    }, 3000);
  }

  set hide(value){
    if(value){
      this.main.classList.add('d-none');
    }else{
      this.main.classList.remove('d-none');
    }
  }

  _onClickPasswordToggleShow(e) {
    e.preventDefault();
    
    const icon = e.currentTarget.querySelector('.material-icons');
    
    if (this._inputPasswordEl.type == 'text'){
      this._inputPasswordEl.type = 'password';
      icon.innerText = 'visibility';
    } else {
      this._inputPasswordEl.type = 'text';
      icon.innerText = 'visibility_off';
    }
  }
  
  _onSubmit(e) {
    e.preventDefault();

    if (this._sending){
      return false;
    }
    
    if (!this._validateForm()){
      return false;
    }
    
    this._submitData();
    
    return true;
  }
  
  _validateForm() {
    let formOk = true;
    
    if(this._inputEmail.isEmpty) {
      formOk = false;
      this._inputEmail.errorMessage = '*Required field'
      this._inputEmail.error = true;
    } else if(!this._inputEmail.isValidEmail) {
      formOk = false;
      this._inputEmail.errorMessage = '*Wrong email format';
      this._inputEmail.error = true;
    } else {
      this._inputEmail.error = false;
    }
    
    if(this._inputPassword.isEmpty) {
      formOk = false;
      this._inputPassword.error = true;
    } else {
      this._inputPassword.error = false;
    }
    
    return formOk;
  }
  
  _submitData() {
    this._sending = true;
    this._btnLogin.classList.add('button--loading');
    
    Auth.loginV2(this._inputEmail.value, this._inputPassword.value)
    .then((data) => {
      GTMEvent('login',{method:'Email', user_type: data.type});
      this._redirect();
    })
    .catch((data) => {
      this._inputEmail.reset();
      this._inputPassword.reset();
      this._loginErrorToast.show();
      
    })
    .finally(() => {
      this._sending = false;
      this._btnLogin.classList.remove('button--loading');
    })
  }
  
  _resetFields() {
    this._inputEmail.reset();
    this._inputPassword.reset();
  }

  _redirect(){
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    const defaultRedirect = `${BASE_URL}bsuite`;

    if (params.redirect == '') {
      window.location = defaultRedirect;
    } else {
      try {
        const redirectUrl = new URL(params.redirect);
        const baseUrl = new URL(BASE_URL);

        if (redirectUrl.hostname == baseUrl.hostname) {
          window.location = params.redirect;
        } else {
          window.location = defaultRedirect;
        }
      } catch (error) {
        window.location = defaultRedirect;
      }
    }
  }

}

export default Login;
